import React from 'react'
import { format } from 'date-fns'

import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { determineStatus } from '../../assignment/components/common/AssignmentUtils'

const AssignmentsList = ({ id, header, location, assignments, dispositionDate }) =>
  <div className='assignments-list' id={id}>
    <h3>{header}</h3>
    Total assignments: {assignments.list ? assignments.list.length : ''}
    <table>
      <thead>
        <tr>
          <th scope='col'>LIN</th>
          <th scope='col'>Assignment Date</th>
          <th scope='col'>Status / Disposition</th>
          {dispositionDate && <th scope='row'>Disposition Date</th>}
          <th scope='col'>Appraisal Type</th>
          <th scope='col'>Property Address</th>
        </tr>
      </thead>
      <tbody>
        {assignments.fetching && <tr><td colSpan={dispositionDate ? '6' : '5'}>Loading...</td></tr>}
        {assignments.list && !assignments.error && !assignments.fetching
          && assignments.list.map(assignment =>
            <tr key={assignment.lin+assignment.appraisalCode+assignment.dispositionCode}>
              <th scope='row'>
                <LgyLink to={`${location}/${assignment.lin}`}>{assignment.lin}</LgyLink>
              </th>
              <td>{format(assignment.assignmentDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>
              <td>{determineStatus(assignment.dispositionCode)}</td>
              {dispositionDate && <td>{format(assignment.currentDispositionDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}</td>}
              <td>{assignment.appraisalCode}{assignment.nadlAppraisalIndicator ? '-NADL' : ''}</td>
              <td className='property-address'>
                {assignment.streetNumber}&nbsp;{assignment.addressOne}
                {assignment.addressTwo ? <span><br />{assignment.addressTwo}</span> : ''}
                <br />
                {`${assignment.city}, ${assignment.state} ${assignment.zip}${assignment.zipPlusFour ? '-' + assignment.zipPlusFour : ''}`}
                <br />
                {assignment.county}
              </td>
            </tr>)}
        {assignments.list && !assignments.error && !assignments.fetching && assignments.list.length < 1
          && <tr><td colSpan={dispositionDate ? '6' : '5'}>No assignments found.</td></tr>}
        {assignments.error && <tr><td colSpan={dispositionDate ? '6' : '5'}>Error: Unable to load assignments.</td></tr>}
      </tbody>
    </table>
  </div>

export default AssignmentsList
